// WebSocketContext.tsx
import React, { useContext, useMemo, useRef } from 'react';

import config from '../../config/config';
import getFirstSubdomain from '../../shared-functions/DomainsplitFunction';
import webSocketService from '../../websocket/wsService';
import { useBranding } from '../BrandingContext';

import WebSocketContext from './WebSocketContext';



export interface WebSocketContextType {
  webSocketService: typeof webSocketService;
  connectWebSocket: (deviceId?: string | number) => void;
}

/**
 * Web socket provider
 * @param param0
 * @returns
 */
export function WebSocketProvider({ children }: { children: React.ReactNode }) {
  const { brandData } = useBranding();
  const domain = getFirstSubdomain();

  // Track the active device websocket URL
  const currentConnectionReference = useRef<string | null>(null);

  /**
   * connectWebSocket
   * @param deviceId 
   */
  const connectWebSocket = (deviceId?: string | number) => {
    const newUrl = `${domain && brandData?.webSocketUrl ? brandData?.webSocketUrl : config.websocketUrl}/facility/${deviceId}`;

    // 🔄 Always disconnect before connecting new device
    if (currentConnectionReference.current) {
      console.log(`🔌 Disconnecting old device WS: ${currentConnectionReference.current}`);
      webSocketService.disconnect();
    }

    // 🌐 Connect new websocket
    console.log(`🌐 Connecting new device WS: ${newUrl}`);
    webSocketService.connect(newUrl);

    // Save new reference
    currentConnectionReference.current = newUrl;
  };

  const contextValue = useMemo(
    () => ({
      webSocketService,
      connectWebSocket,
    }),
    []
  );

  return (
    <WebSocketContext.Provider value={contextValue}>
      {children}
    </WebSocketContext.Provider>
  );
}

/**
 * Safe hook — throws error if used outside provider
 */
export const useWebSocket = (): WebSocketContextType => {
  const context = useContext(WebSocketContext);
  if (!context) {
    throw new Error('useWebSocket must be used within a WebSocketProvider');
  }
  return context;
}